<template>
  <el-dialog
    :title="title"
    :visible.sync="econ_dialogVisible"
    width="70%"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="addressWrap">
      <el-form :model="form" :rules="rules" ref="form" label-width="170px">
        <el-form-item prop="annualYear" label="选择年度">
          <el-date-picker
          :disabled="!!this.id"
            v-model="form.annualYear"
            type="year"
            placeholder="选择年度"
            value-format="yyyy"
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="annualRevenue" label="年营业收入(万元)">
          <el-input-number
            v-model="form.annualRevenue"
            :controls="false"
            style="width:100%"
            :min="0"
            :max="9999999"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="annualProfit" label="年利润(万元)">
          <el-input-number
            v-model="form.annualProfit"
            :controls="false"
            style="width:100%"
            :min="-9999999"
            :max="9999999"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="researchInvestment" label="科研投入(万元)">
          <el-input-number
            v-model="form.researchInvestment"
            :controls="false"
            style="width:100%"
            :min="0"
            :max="9999999"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="iprInvestment" label="知识产权投入(万元)">
          <el-input-number
            v-model="form.iprInvestment"
            :controls="false"
            style="width:100%"
            :min="0"
            :max="9999999"
          ></el-input-number>
        </el-form-item>
      </el-form>
    </div>
    <div style="text-align:center;" class="mt30">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { econSave, econUpdate, econView } from "@/api/index";
export default {
  props: {
    econ_dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      title: "新增",
      form: {
        annualYear: "",
        annualRevenue: 0,
        annualProfit: 0,
        researchInvestment: 0,
        iprInvestment: 0
      },
      rules: {
        annualYear: [
          { required: true, message: "请选择年度", trigger: "change" }
        ],
        annualRevenue: [
          { required: true, validator:this.$reg.realnumber, trigger: "change" }
        ],
        annualProfit: [
          { required: true, message:"清输入年利润", trigger: "change" }
        ],
        researchInvestment: [
          { required: true,validator:this.$reg.realnumber, trigger: "change" }
        ],
        iprInvestment: [
          { required: true,validator:this.$reg.realnumber, trigger: "change" }
        ]
      }
    };
  },
  mounted() {
    if (this.id) {
      this.title = "修改";
      econView(this.id).then(res => {
        this.form = {...res.data,
            annualYear:String(res.data.annualYear)
        };
      });
    }
  },
  methods: {
    handleClose() {
      this.$emit("update:econ_dialogVisible", false);
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.id) {
            //修改
            econUpdate({
              ...this.form,
              annualYear:Number(this.form.annualYear)
            }).then(res => {
              if (res.status == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success"
                });
                this.$emit("update:econ_dialogVisible");
                this.$emit("refresh");
              }
            });
          } else {
            //新增
            econSave({
              ...this.form,
              annualYear:Number(this.form.annualYear)
            }).then(res => {
              if (res.status == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success"
                });
                this.$emit("update:econ_dialogVisible");
                this.$emit("refresh");
              }
            });
          }
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
</style>